import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import Modal from '../../../Modal';
import { ReactComponent as PdfIcon } from '../../svg/file-pdf.svg';
import { ReactComponent as OpenIcon } from '../../svg/square-link.svg';
import { DocContent, DocTitle, FileIcon, PreviewContainer, PreviewImage } from './styles';
import utils from 'utils';

interface PreviewProps {
  page: number;
  imageBase64: string;
  width: number;
  docSource?: string;
}

export const Preview: React.FC<PreviewProps> = ({ imageBase64, width, docSource }) => {
  const theme = useTheme();
  const t = utils.intl.useTranslator();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const imageDataUrl = `data:image/png;base64,${imageBase64}`;
  const displayTitle = utils.app.textTranslated('document', t, 'Document');

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenSource = () => {
    window.open(docSource, '_blank');
  };

  return (
    <>
      <PreviewContainer onClick={docSource ? handleOpenSource : handleOpenModal}>
        {imageBase64 && (
          <PreviewImage
            isDark={!!docSource}
            src={imageDataUrl}
            alt={
              docSource
                ? utils.app.textTranslated('documentPreview', t, 'Document preview')
                : utils.app.textTranslated('imagePreview', t, 'Image preview')
            }
          />
        )}
        {docSource && (
          <DocContent>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <FileIcon>
                <PdfIcon />
              </FileIcon>
              <DocTitle>{displayTitle}</DocTitle>
            </div>

            <OpenIcon color={theme.colorPalette.grey.grey6} />
          </DocContent>
        )}
      </PreviewContainer>

      <Modal open={isModalOpen} onClose={handleCloseModal} closingOnOverlayClick={true} isDraggable={false}>
        <div>
          <Modal.Header title={displayTitle} />
          <Modal.Content>
            <img src={imageDataUrl} alt="Document preview" style={{ maxWidth: width }} />
          </Modal.Content>
        </div>
      </Modal>
    </>
  );
};
